import {SERVER_HOST_QR} from '@/config';
const host= SERVER_HOST_QR

import i18n, {selectedLocale} from '@/helpers/i18n';
import {ActionTree, MutationTree} from 'vuex';
import {RootState} from '@/store/types';
import axios from 'axios';

interface State{
  interestedMens:{
    data:{} | null,
    load:boolean,
    error:string | null
  },
  statisticSurvey:{
    data:{} | null,
    load:boolean,
    error:string | null
  },
  scanStandman:{
    data:{} | null,
    load:boolean,
    error:string | null
  },
  chipStatics:{
    data:{} | null,
    load:boolean,
    error:string | null
  },
  scanProducts:{
    data:{} | null,
    load:boolean,
    error:string | null
  },
  scanVisitors:{
    data:{} | null,
    load:boolean,
    error:string | null
  },
  scanStand:{
    data:{} | null,
    load:boolean,
    error:string | null
  },
  scanCategory:{
    data:{} | null,
    load:boolean,
    error:string | null
  },

}
const state: State = {
  interestedMens:{
    data:null,
    load:false,
    error: null
  },
  statisticSurvey:{
    data:null,
    load:false,
    error: null
  },
  scanStandman:{
    data:null,
    load:false,
    error: null
  },
  chipStatics: {
    data:null,
    load:false,
    error:null
  },
  scanProducts:{
    data:null,
    load:false,
    error:null
  },
  scanVisitors:{
    data:null,
    load:false,
    error:null
  },
  scanStand:{
    data:null,
    load:false,
    error:null
  },
  scanCategory:{
    data:null,
    load:false,
    error:null
  }
}

const getters = {
  GetChipStatistics:(state:State)=>state.chipStatics,
  GetScanProducts:(state:State)=>state.scanProducts,
  GetScanVisitors:(state:State)=>state.scanVisitors,
  GetScanStand:(state:State)=>state.scanStand,
  GetScanCategory:(state:State)=>state.scanCategory,
  GetScanStandman:(state:State)=>state.scanStandman,
  GetInterestedMens:(state:State)=>state.interestedMens, GetStatisticSurvey:(state:State)=>state.statisticSurvey,
}


const mutations: MutationTree<State> = {
  setChipsStatisticsData(state:State, payload:{}){
    state.chipStatics.data = payload
  },
  setChipsStatisticsLoad(state:State, payload:boolean){
    state.chipStatics.load = payload
  },
  setChipsStatisticsError(state:State, payload:string | null){
    state.chipStatics.error = payload
  },
  setScanProductsData(state:State, payload:{}){
    state.scanProducts.data = payload
  },
  setScanProductsLoad(state:State, payload:boolean){
    state.scanProducts.load = payload
  },
  setScanProductsError(state:State, payload:string | null){
    state.scanProducts.error = payload
  },
  setScanVisitorsData(state:State, payload:{}){
    state.scanVisitors.data = payload
  },
  setScanVisitorsLoad(state:State, payload:boolean){
    state.scanVisitors.load = payload
  },
  setScanVisitorsError(state:State, payload:string | null){
    state.scanVisitors.error = payload
  },
  setScanStandData(state:State, payload:{}){
    state.scanStand.data = payload
  },
  setScanStandLoad(state:State, payload:boolean){
    state.scanStand.load = payload
  },
  setScanStandError(state:State, payload:string | null){
    state.scanStand.error = payload
  }
  ,
  setScanCategoryData(state:State, payload:any){
    state.scanCategory.data = payload
  },
  setScanCategoryLoad(state:State, payload:boolean){
    state.scanCategory.load = payload
  },
  setScanCategoryError(state:State, payload:string | null){
    state.scanCategory.error = payload
  },
  setScanStandmanData(state:State, payload:any){
    state.scanStandman.data = payload
  },
  setScanStandmanLoad(state:State, payload:boolean){
    state.scanStandman.load = payload
  },
  setScanStandmanError(state:State, payload:string | null){
    state.scanStandman.error = payload
  },
  setStaticsSurveyData(state:State, payload:any){
    state.statisticSurvey.data = payload
  },
  setStaticsSurveyLoad(state:State, payload:boolean){
    state.statisticSurvey.load = payload
  },
  setStaticsSurveyError(state:State, payload:string | null){
    state.statisticSurvey.error = payload
  },
  setInterestedMensData(state:State, payload:any){
    state.interestedMens.data = payload
  },
  setInterestedMensLoad(state:State, payload:boolean){
    state.interestedMens.load = payload
  },
  setInterestedMensError(state:State, payload:string | null){
    state.interestedMens.error = payload
  },
  clearDataInterestMens(state:State){
    state.interestedMens.load = false
    state.interestedMens.data = null
  }

}

const actions: ActionTree<State, RootState> = {
 async getChipsStatisticsFormServer({commit}) {
    try {
      commit('setChipsStatisticsLoad', true)
      const {data} = await axios.get(host+'statistic/company/stand/general-statistical-figures')
      commit('setChipsStatisticsData', data.data)
      commit('setChipsStatisticsLoad', false)

    }catch (e) {
      commit('setChipsStatisticsError', 'Что-то пошло не так ... ')
    }
  },
 async getScanProductsFormServer({commit}) {
    try {
      commit('setScanProductsLoad', true)
      const {data} = await axios.get(host+'statistic/company/count-scans-products')
      commit('setScanProductsData', data.data)
      commit('setScanProductsLoad', false)

    }catch (e) {
      commit('setScanProductsError', 'Что-то пошло не так ... ')
    }
  },
 async getScanVisitorsFormServer({commit}) {
    try {
      commit('setScanVisitorsLoad', true)
      const {data} = await axios.get(host+'statistic/company/timestamps-with-visitor-count')
      commit('setScanVisitorsData', data.data)
      commit('setScanVisitorsLoad', false)

    }catch (e) {
      commit('setScanVisitorsError', 'Что-то пошло не так ... ')
    }
  },
 async getScanStandFormServer({commit}) {
    try {
      commit('setScanStandLoad', true)
      const {data} = await axios.get(host+'statistic/company/timestamps-with-company-scan-count')
      commit('setScanStandData', data.data)
      commit('setScanStandLoad', false)

    }catch (e) {
      commit('setScanStandError', 'Что-то пошло не так ... ')
    }
  },
 async getScanCategoryFormServer({commit}) {
    try {
      commit('setScanCategoryLoad', true)
      const {data} = await axios.get(host+'statistic/company/count-scan-products-by-thematics')
      commit('setScanCategoryData', data.data)
      commit('setScanCategoryLoad', false)

    }catch (e) {
      commit('setScanCategoryError', 'Что-то пошло не так ... ')
    }
  },
 async getScanStandmanFormServer({commit}) {
    try {
      commit('setScanStandmanLoad', true)
      const {data} = await axios.get(host+'statistic/company/stand-men')
      commit('setScanStandmanData', data)
      commit('setScanStandmanLoad', false)

    }catch (e) {
      commit('setScanStandmanError', 'Что-то пошло не так ... ')
    }
  },
 async getStaticsSurveyFormServer({commit}) {
    try {
      commit('setStaticsSurveyLoad', true)
      const {data} = await axios.get(host+'statistic/company/survey')
      commit('setStaticsSurveyData', data)
      commit('setStaticsSurveyLoad', false)

    }catch (e) {
      commit('setStaticsSurveyError', 'Что-то пошло не так ... ')
    }
  },
 async getInterestedMensFormServer({commit},payload:any) {
    try {
      commit('setInterestedMensLoad', true)
      const {data} = await axios.get(host+'statistic/company/product/'+payload+'/scanned-badges')
      commit('setInterestedMensData', data)
      commit('setInterestedMensLoad', false)

    }catch (e) {
      commit('setInterestedMensError', 'Что-то пошло не так ... ')
    }
  },
}






export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
